var _module_exports = "<div class=\"modal\">\n  <div class=\"modal--overlay\"></div>\n  <div class=\"modal--content\">modal content</div>\n</div>\n";;
var path = 'views/directives/modal.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;